import { useMutation } from "react-query";
import { getUserDetails, getUserSettings, setUserSettings } from "../services/user.service";

export function useGetUser() {
    return useMutation(getUserDetails);
}

export function useGetUserSettings() {
    return useMutation(getUserSettings);
}

export function useSetUserSettings() {
    return useMutation(setUserSettings);
}